export default __webpack_public_path__ + "static/media/ThaiSansNeue-Regular.d6e844a4.otf";